import { Checkbox, FormControlLabel } from '@mui/material';
import { CheckBoxContainer } from './torihikiginkoCondition.styles';
import React, { ReactNode } from 'react';

interface KinyuInfo {
    kinyuId: string
    kinyuValue: string
}

interface KinyuInfoProps {
    kinyuInfoList: KinyuInfo[],
    searchHidden: Set<string>,
    checkCode: Set<string>,
    toggleKinyu(v: string): void,
    children?: ReactNode;
}

interface KinyuCheckBoxProps {
    kinyuInfo: KinyuInfo,
    checked: boolean,
    toggleKinyu(v: string): void,
}

const KinyuInfoListContainer = React.memo(KinyuInfoListComponent)
function KinyuInfoListComponent(props: KinyuInfoProps) {
    return (
        <CheckBoxContainer>
            {props.kinyuInfoList.map((v) => {
                let checked = props.checkCode.has(v.kinyuId)
                return (
                    <>
                        {!props.searchHidden.has(v.kinyuId) && <><KnyuCheckBoxCompornent kinyuInfo={v} checked={checked} toggleKinyu={props.toggleKinyu} /><br /></>}
                    </>
                )
            })}
        </CheckBoxContainer>
    )
}

const KnyuCheckBoxCompornent = React.memo((props: KinyuCheckBoxProps) => {
    return (<FormControlLabel
        sx={{ whiteSpace: "pre-wrap" }}
        label={props.kinyuInfo.kinyuValue}
        key={props.kinyuInfo.kinyuId}
        control={<Checkbox checked={props.checked} onChange={() => props.toggleKinyu(props.kinyuInfo.kinyuId)} />} />
    )
})

interface ShitenInfo {
    shitenId: string
    shitenValue: string
}

interface ShitenInfoProps {
    shitenInfoList: ShitenInfo[],
    searchHidden: Set<string>,
    checkCode: Set<string>,
    toggleShiten(v: string): void,
    children?: ReactNode;
}

interface ShitenCheckBoxProps {
    shitenInfo: ShitenInfo,
    checked: boolean,
    toggleShiten(v: string): void,
}

const ShitenInfoListContainer = React.memo(ShitenInfoListComponent)

function ShitenInfoListComponent(props: ShitenInfoProps) {
    return (
        <CheckBoxContainer>
            {props.shitenInfoList.map((v) => {
                let checked = props.checkCode.has(v.shitenId)
                return (
                    <>
                        {!props.searchHidden.has(v.shitenId) && <><ShitenCheckBoxCompornent shitenInfo={v} checked={checked} toggleShiten={props.toggleShiten} /><br /></>}
                    </>
                )
            })}
        </CheckBoxContainer>
    )
}

const ShitenCheckBoxCompornent = React.memo((props: ShitenCheckBoxProps) => {
    return (<FormControlLabel
        sx={{ whiteSpace: "pre-wrap" }}
        label={props.shitenInfo.shitenValue}
        key={props.shitenInfo.shitenId}
        control={<Checkbox checked={props.checked} onChange={() => props.toggleShiten(props.shitenInfo.shitenId)} />} />
    )
})

export { KinyuInfoListContainer, ShitenInfoListContainer }
